// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ProjectUserRole,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  projectId: __t.u32().name("project_id"),
  userIdentity: __t.identity().name("user_identity"),
  get role() {
    return ProjectUserRole;
  },
  assignedAt: __t.timestamp().name("assigned_at"),
  assignedBy: __t.identity().name("assigned_by"),
});
